// extracted by mini-css-extract-plugin
export var modal = "modal-questionnaire-module--modal--E+W50";
export var thankyou = "modal-questionnaire-module--thankyou--j2mVt";
export var widget = "modal-questionnaire-module--widget--HkXgD";